<template>
  <v-container fluid>
    <v-row dense>
      <v-col cols="12" sm="4" md="4" lg="4" xl="4">
        <!-- 検索用のテキスト入力 -->
        <v-text-field
          v-model="titleFilterValue"
          label="ﾀｲﾄﾙ検索"
          placeholder="ﾀｲﾄﾙ検索"
          outlined
          dense
          clearable
          hide-details="auto"
          background-color="white"
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="2" md="2" lg="2" xl="2">
        <!-- 検索用のテキスト入力 -->
        <v-autocomplete
          v-model="groupFilterValue"
          label="グループ指定"
          placeholder="グループ指定"
          :items="groupNames"
          outlined
          dense
          clearable
          hide-details="auto"
          background-color="white"
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" sm="2" md="2" lg="2" xl="2">
        <!-- 検索用のテキスト入力 -->
        <v-autocomplete
          v-model="postUsersFilterValue"
          label="投稿者指定"
          placeholder="投稿者指定"
          :items="postUsers"
          outlined
          dense
          clearable
          hide-details="auto"
          background-color="white"
        ></v-autocomplete>
      </v-col>
      <v-col cols="6" sm="2" md="2" lg="2" xl="2">
        <v-switch 
          v-model="viewUnreadOnly"
          @click="changeFilter(true)"
          dense
          class="mt-1"
          label="未読のみ"
          hide-details="auto"
        />
      </v-col>
      <v-col cols="6" sm="2" md="2" lg="2" xl="2">
        <v-switch 
          v-model="viewFavoriteOnly"
          @click="changeFilter(false)"
          dense
          class="mt-1"
          label="お気に入りのみ"
          hide-details="auto"
        />
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12">
        <v-tabs fixed-tabs v-model="tab">
          <v-tab href="#contact">
            校内連絡
            <v-btn color="red" small icon outlined v-if="unreadContactCount > 0 && unreadContactCount <= 99">{{ unreadContactCount }}</v-btn>
            <v-btn color="red" small icon outlined v-if="unreadContactCount > 99">99+</v-btn>
          </v-tab>
          <v-tab href="#survey">
            アンケート
            <v-btn color="red" small icon outlined v-if="unreadSurveysCount > 0 && unreadSurveysCount <= 99">{{ unreadSurveysCount }}</v-btn>
            <v-btn color="red" small icon outlined v-if="unreadSurveysCount > 99">99+</v-btn>
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab" touchless>
          <v-tab-item value="contact">
            <v-data-table
              :headers="headers"
              :items="contacts"
              :items-per-page.sync="parPageContact"
              :footer-props="{'items-per-page-options': [10, 20, 30, 50, 100, -1]}"
              dense
              disable-sort
              @click:row="onClickContactDetails"
              :item-class="rowStyleContact"
              :loading="isContactsLoding" loading-text="読込中"
              ref="contact"
            >
              <!-- 投稿日と投稿者 -->
              <template #[`item.postUser`]="{ item }">
                <v-row dense><v-col cols="12" justify="center">{{ item.openDate }}</v-col></v-row>
                <v-row dense><v-col cols="12" justify="center">{{ item.postUser }}</v-col></v-row>
              </template>
              <template #[`item.target`]="{ item }">
                <v-icon x-large v-if="item.studentFlg">$student</v-icon>
                <v-icon x-large v-if="item.parentFlg">$parent</v-icon>
                <v-icon x-large v-if="item.teacherFlg">$teacher</v-icon>
                <div v-if="item.targetSelectFlg">【限定】</div>
              </template>
              <!-- コメントフラグ -->
              <template #[`item.commentFlg`]="{ item }">
                <v-icon class="ml-2" v-if="item.commentFlg">mdi-comment-text-outline</v-icon>
                <v-icon v-if="item.unreadCommentCount > 0" large color="red">mdi-new-box</v-icon>
              </template>
              <!-- お気に入り -->
              <template #[`item.favoriteFlg`]="{ item }">
                <v-btn icon v-if="item.favoriteFlg" :disable="true"><v-icon color="orange">mdi-star</v-icon></v-btn>
                <v-btn icon v-if="!item.favoriteFlg" :disable="true"><v-icon>mdi-star-outline</v-icon></v-btn>
              </template>
              <!-- グループ名と代表者 -->
              <template #[`item.groupName`]="{ item }">
                <v-row dense><v-col cols="12" justify="center">{{ item.groupName }}</v-col></v-row>
                <v-row dense><v-col cols="12" justify="center">{{ item.ownerUser }}</v-col></v-row>
              </template>
              <!-- 既読/未読 -->
              <template #[`item.unreadFlg`]="{ item }">
                {{ item.unreadState }}
              </template>
            </v-data-table>

          </v-tab-item>
          <v-tab-item value="survey">
            <v-data-table
              :headers="surveyheaders"
              :items="surveylist"
              :items-per-page.sync="parPageSurvey"
              :footer-props="{'items-per-page-options': [10, 20, 30, 50, 100, -1]}"
              dense
              disable-sort
              @click:row="onClickSurveyDetails"
              :item-class="rowStyleSurvey"
              :loading="isSurveysLoding" loading-text="読込中"
              ref="survey"
            >
              <!-- タイトルと締切日 -->
              <template #[`item.title`]="{ item }">
                <v-row dense><v-col cols="12" justify="center">{{ item.title }}</v-col></v-row>
                <v-row dense v-if="item.limitOverFlg"><v-col cols="12" justify="center" class="red--text">{{ item.limitDate }}</v-col></v-row>
                <v-row dense v-if="!item.limitOverFlg"><v-col cols="12" justify="center">{{ item.limitDate }}</v-col></v-row>
              </template>
              <!-- 投稿日と投稿者 -->
              <template #[`item.postUser`]="{ item }">
                <v-row dense><v-col cols="12" justify="center">{{ item.openDate }}</v-col></v-row>
                <v-row dense><v-col cols="12" justify="center">{{ item.postUser }}</v-col></v-row>
              </template>
              <template #[`item.target`]="{ item }">
                <v-icon x-large v-if="item.studentFlg">$student</v-icon>
                <v-icon x-large v-if="item.parentFlg">$parent</v-icon>
                <v-icon x-large v-if="item.teacherFlg">$teacher</v-icon>
                <div v-if="item.targetSelectFlg">【限定】</div>
              </template>
              <!-- グループ名と代表者 -->
              <template #[`item.groupName`]="{ item }">
                <v-row dense><v-col cols="12" justify="center">{{ item.groupName }}</v-col></v-row>
                <v-row dense><v-col cols="12" justify="center">{{ item.ownerUser }}</v-col></v-row>
              </template>
              <!-- お気に入り -->
              <template #[`item.favoriteFlg`]="{ item }">
                <v-btn icon v-if="item.favoriteFlg" :disable="true"><v-icon color="orange">mdi-star</v-icon></v-btn>
                <v-btn icon v-if="!item.favoriteFlg" :disable="true"><v-icon>mdi-star-outline</v-icon></v-btn>
              </template>
              <template #[`item.unreadFlg`]="{ item }">
                {{ item.inputState }}
              </template>
            </v-data-table>
          </v-tab-item>
        </v-tabs-items>

      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">

      </v-col>
    </v-row>
    <v-btn fixed fab bottom left color="secondary" @click="reload" style="bottom: 50px">
      <v-icon color="white">mdi-refresh</v-icon>
    </v-btn>
    <v-btn fixed fab bottom right color="secondary" @click="toGroupSelect" style="bottom: 50px">
      <v-icon color="white">mdi-pencil</v-icon>
    </v-btn>
  </v-container>
</template>

<script>
//import { httpsCallable, getFunctions } from "firebase/functions";
import Enumerable from "linq";
export default {
  data() {
    return {
      tab: 'contact',
      titleFilterValue: "",
      postUsersFilterValue: "",
      groupFilterValue: "",
      viewUnreadOnly: false,
      viewFavoriteOnly: false,
      postUsers : [],
      groupNames : [],
      headers: [
        { text: "タイトル", value: "title", class: "px-0", filter: this.titleFilter },
        { text: "グループ名/代表者", value: "groupName", class: "px-0", filter: this.groupNameFilter},
        { text: "対象", value: "target", class: "px-0" },
        { text: "更新日時/更新者", value: "postUser", class: "px-0", filter: this.postUserFilter },
        { text: "コメント", value: "commentFlg", class: "px-0" },
        { text: "お気に入り", value: "favoriteFlg", class: "px-0", filter: this.favoriteFilter },
        { text: "既読/未読", value: "unreadFlg", class: "px-0", filter: this.unreadFilter },
      ],
      contacts: [],
      surveyheaders : [
        { text: "タイトル/回答期限", value: "title", class: "px-0", filter: this.titleFilter },  
        { text: "グループ名/代表者", value: "groupName", class: "px-0", filter: this.groupNameFilter},
        { text: "対象", value: "target", class: "px-0" },
        { text: "更新日時/更新者", value: "postUser", class: "px-0", filter: this.postUserFilter },
        { text: "お気に入り", value: "favoriteFlg", class: "px-0", filter: this.favoriteFilter },
        { text: "既読/未読", value: "unreadState", class: "px-0" },
        { text: "入力状況", value: "unreadFlg", class: "px-0", filter: this.unreadFilter },
      ],
      surveylist : [],
      isContactsLoding: false,
      isSurveysLoding: false,
      parPageContact: 30,
      parPageSurvey: 30,
      unreadContactCount: 0,
      unreadSurveysCount: 0,
    };
  },
  watch: {
  },
  // 初期表示時データ読み込み
  async created() {
    await this.reload();
  },
  methods: {
    // 連絡詳細
    onClickContactDetails(item) {
      // フィルタされた配列の取得
      let items = this.$refs.contact.$children[0].filteredItems;
      // 連絡IDのみ抽出
      var contactListBuff = Enumerable.from(items).select(x => { return x.messageId }).toArray();
      var contactListIndex = contactListBuff.indexOf(item.messageId);

      this.$router.push({
        name: "ContactDetails",
        params: {
          messageId: item.messageId,
          contactListBuff: contactListBuff,
          contactListIndex: contactListIndex,
        } 
      });
    },
    // アンケート回答
    onClickSurveyDetails(item) {

      // フィルタされた配列の取得
      let items = this.$refs.survey.$children[0].filteredItems;
      // 調査IDのみ抽出
      var surveyListBuff = Enumerable.from(items).select(x => { return x.responseId }).toArray();
      var surveyListIndex = surveyListBuff.indexOf(item.responseId);

      this.$router.push({
        name: "SurveyDetails",
        params: {
          responseId : item.responseId,
          surveyListBuff: surveyListBuff,
          surveyListIndex: surveyListIndex,
        } 
      });
    },
    // ページ再読込
    async reload() {
    },


    rowStyleContact: function (item) {
      return item.unreadFlg == true ? 'not-yet-style' : 'do-style'
    },
    rowStyleSurvey: function (item) {
      return item.inputFlg == true ? 'do-style' : 'not-yet-style'
    },
    toGroupSelect() {
      this.$router.push({
        name: "GroupSelect",
      });
    },
  },  
};
</script>

<style>
.do-style {
  background-color: rgb(182, 182, 182)
}
.do-style > td {
  padding-left: 0px !important;
  padding-right: 0px !important;
}
.not-yet-style {
  background-color: rgb(255, 255, 255)
}
.not-yet-style > td {
  padding-left: 0px !important;
  padding-right: 0px !important;
}

</style>